import apiClient from '../utils/apiClient';

/**
 * #005135 — "tập việc": NV mới chỉ nhận **ca gãy** (ca phụ = ca không thu ngân), vẫn làm đơn
 * nước bình thường để luyện tay.
 *
 * ⚠️ #190609 lượt4 — "NV mới" KHÔNG còn là "30 ngày đầu kể từ join_date" mà là **chưa đủ số ca
 * ĐƯỢC DUYỆT** (25/38 NV trên production không có `join_date` nên mốc ngày xếp nhầm hàng loạt).
 * #011742 (18/09/2026) — ngưỡng giảm còn 8 ca (trước là 16). Số THẬT do server trả
 * (`shifts_required`), đừng ghim cứng ở giao diện.
 */
export const newHireTrainingAPI = {
  /** Danh sách NV đang trong tháng đầu tập việc của 1 chi nhánh + tiến độ số đơn đã làm. */
  getBranchProgress: async (branchId) => {
    return await apiClient.get({ url: `/new-hire-training/branch/${branchId}` });
  },

  /** Tiến độ của 1 nhân viên (dùng khi cần kiểm trước lúc xếp ca chính). */
  getEmployeeProgress: async (employeeId) => {
    return await apiClient.get({
      url: `/new-hire-training/employee/${employeeId}`,
    });
  },
};

export default newHireTrainingAPI;
